import { default as Tabs } from './Tabs';

export default Tabs;
export * from './TabsProps';
